import React from 'react'
import { AccountDetails } from '../../../types'
import { getServerTimeShortDate } from '../../../utils/formatter'
import { StandardDl } from './StandardDl'

export const DateClosedDl: React.FC<{
  account: AccountDetails
}> = ({ account }) =>
  account.acctClosedDate ? (
    <StandardDl
      title="Date Closed:"
      definition={getServerTimeShortDate(account.acctClosedDate)}
    />
  ) : null
